import React from 'react'
import { object, string } from 'prop-types'
import { css } from '@emotion/react'

import Header from 'gatsby-theme-marketplace-base/src/components/Product/Header/Header'

import mediaQueries from '../../../layout/media-queries'

const wrapperCss = css`
  ${mediaQueries.smallScreen(-280)} {
    padding-top: 16px;
  }

  ${mediaQueries.smallScreen()} {
    top: 0;
    padding-top: 32px;
  }

  ${mediaQueries.mediumScreen(100)} {
    top: 0;
    padding-top: 32px;
  }
`

const HeaderWrapper = ({ className, ...props }) => {
  return <Header innerRef={props.innerRef} css={wrapperCss} {...props} />
}

HeaderWrapper.propTypes = {
  innerRef: object,
  className: string,
}

export default React.forwardRef((props, ref) => (
  <HeaderWrapper innerRef={ref} {...props} />
))
